import { useRoutes } from 'react-router-dom';
import vivosolRouteConfig from '../../routes/vivosolRouteConfig';

function VivosolRoutes() {
  return useRoutes(vivosolRouteConfig);
}

export default VivosolRoutes;
